module.exports = __webpack_public_path__ + "6b18c6386ec4f37287ff885529f0090c.svg";